import React from 'react';
import {ModuleInjectedProps, PaymentModule, VehicleDebitsProps} from './types';
import {VehicleDebitsHeader} from './components/VehicleDebitsHeader';
import {VehicleDebitsResume} from './components/VehicleDebitsResume';

function VehicleDebitsComponent(_props: VehicleDebitsProps) {
  return null;
}

VehicleDebitsComponent.Header = VehicleDebitsHeader;

VehicleDebitsComponent.Resume = function Resume({
  placa,
  totalValue,
  installment,
  baseValue,
  serviceTaxIsCard,
  serviceTaxValue,
  usaBaratinhas,
  descontoBaratinhas,
}: VehicleDebitsProps & ModuleInjectedProps) {
  return (
    <VehicleDebitsResume
      placa={placa}
      totalValue={totalValue}
      installment={installment}
      serviceTaxIsCard={serviceTaxIsCard}
      serviceTaxValue={serviceTaxValue}
      baseValue={baseValue}
      usaBaratinhas={usaBaratinhas}
      descontoBaratinhas={descontoBaratinhas}
    />
  );
};

export const VehicleDebits = VehicleDebitsComponent as PaymentModule<VehicleDebitsProps>;
